import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const spinner = this.injector.get(NgxSpinnerService);

    console.error('🔥 GLOBAL ERROR:', error);

    // SAFETY: always hide spinner on any crash
    try {
      spinner.hide();
    } catch (_) {}

    throw error; // keep Angular’s default behavior (optional)
  }
}
